/**
 * warmOnUse.ts — the pure decision behind warmCallable (utils/firebaseFunctions.ts).
 *
 * Import-free and clock-free on purpose: the frontend has no test runner, so
 * functions/src/__tests__/warmOnUsePolicy.test.ts loads this file directly
 * (the same way the BE/FE parity tests load frontend modules).
 */

export interface WarmOnUsePolicy {
  /** At most one ping per callable per this many ms (stamped when sent). */
  MIN_INTERVAL_MS: number;
  /** First Taipei hour that may ping (inclusive). */
  START_HOUR: number;
  /** Taipei hour from which pings stop (exclusive). */
  END_HOUR: number;
}

/**
 * Send a warm-up ping now? `taipeiHour` is 0–23 in Asia/Taipei; `lastSentMs` is
 * when this callable was last pinged (undefined = never). A clock that moved
 * backwards (QA time travel) counts as "just sent" until it passes again.
 */
export function shouldSendWarmPing(
  taipeiHour: number,
  nowMs: number,
  lastSentMs: number | undefined,
  policy: WarmOnUsePolicy,
): boolean {
  if (taipeiHour < policy.START_HOUR || taipeiHour >= policy.END_HOUR) return false;
  if (lastSentMs !== undefined && Math.abs(nowMs - lastSentMs) < policy.MIN_INTERVAL_MS) {
    return false;
  }
  return true;
}
